<template>
	<view class="video">
		<video id="myVideo" :src="url" ref="vidref" controls :autoplay="true" :page-gesture="true"></video>
	</view>
</template>

<script>
	export default {
		data(){
			return {
				
			}
		},
		props:{
			url:{
				type:String,
				default:''
			}
		},
		methods:{
			imgClick(e){
				let url = e
				console.log(e);
				uni.previewImage({
					urls: [this.url],
					longPressActions: {
						itemList: ['发送给朋友', '保存图片', '收藏'],
						success: function(data) {
							console.log('选中了第' + (data.tapIndex + 1) + '个按钮,第' + (data.index + 1) + '张图片');
						},
						fail: function(err) {
							console.log(err.errMsg);
						}
					}
				});
			},
		}
	}
</script>

<style scoped lang="scss">
	.video{
		
		text-align: center;
		// width: 90%;
		width: 100%;
		box-sizing: border-box;
		background: #000;
		
	}
	.video{
		height: 450upx;
		width: 100%;
		display: block;
		background: #000;
		video{
			height: 100%;
			width: 100%;
		}
	}
</style>
